import {DependencyError} from "@/errors/errors";
import {t, tc} from "@/i18n";
import {ACCESS_LABELS} from "@/types/Idea";

/**
 * A recusa de remover uma opção de domínio, uma situação de fluxo ou um papel do ambiente que
 * alguma fórmula cita — ou `null` quando o erro é outro. As fórmulas citam pelo alias, que não
 * muda: renomear pode, remover não, porque não haveria o que pôr no lugar. A frase diz onde estão,
 * para o designer ir lá.
 *
 * Uma só para domínio, fluxo e papéis: a regra é a mesma, e a frase também.
 */
export function citingFormulasMessage(err: unknown): string | null {
    if (!(err instanceof DependencyError) || !err.data.dependencies.formulas) return null
    //O atributo pelo nome, ou a pergunta de acesso pelo rótulo dela ("Tarefa › Editável quando"): o
    //servidor aponta também as permissões que citam o que se quer remover
    const formulas = err.data.dependencies.formulas.map(({idea, property, access}) =>
        `${idea} › ${property || (access ? t(ACCESS_LABELS[access]) : '')}`).join(', ')
    return t('error.cited-by-formulas', {formulas})
}

/**
 * A mensagem de um erro ao salvar ou excluir um domínio, dizendo QUANTOS dependem quando
 * a recusa for por uso.
 *
 * O servidor recusa dois casos, com contagens diferentes: excluir o domínio que algum
 * atributo usa (`property`), e remover da lista uma opção que algum item ainda guarda
 * (`instance`). Qualquer outro erro fica com a mensagem genérica de quem chamou.
 *
 * Mora fora dos componentes porque o domínio é salvo em dois lugares — o modal do
 * design do ambiente e as páginas próprias —, e a frase tem de ser a mesma nos dois.
 */
export function domainErrorMessage(err: unknown, fallback: string): string {
    if (!(err instanceof DependencyError)) return fallback
    const cited = citingFormulasMessage(err)
    if (cited) return cited
    const {property, instance} = err.data.dependencies
    //tc e não t: as frases têm singular e plural
    if (property) return tc('error.delete-domain-attributes', property, {count: property})
    if (instance) return tc('error.remove-option-instances', instance, {count: instance})
    return fallback
}
